import Skeleton from 'react-loading-skeleton';
import DynamicFlightDetailsSkeleton from './DynamicFlightDetailsSkeleton';
import LoaderMain from 'components/shared/LoaderMain';
import DynamicHotelDetailsSkeleton from './DynamicHotelDetailsSkeleton';

const DetailsDynamicSkeleton = () => {
  return (
    <div>
      <div className="details-wrapper" style={{ paddingBottom: 0, minHeight: 'unset' }}>
        <div className="default-shadow flex-between dyn-change-header w100p">
          <div style={{ height: 36.5 }}></div>
        </div>
      </div>
      <div className="details-wrapper">
        <div className="details">
          <DynamicFlightDetailsSkeleton />

          <div className="mb-30 default-shadow">
            <div className="title-header-grey title">
              <div style={{ height: 30 }}></div>
            </div>
            <DynamicHotelDetailsSkeleton />
          </div>
          <div className="mb-30 default-shadow">
            <div className="title-header-grey title">
              <div style={{ height: 30 }}></div>
            </div>
            <DynamicHotelDetailsSkeleton />
          </div>
        </div>

        <div className="default-shadow details-summary">
          <div className="title-underline title-header-grey text-lg mb-20">
            <Skeleton width={200} />
          </div>
          <div className="mb-10 text-bold">
            <Skeleton width={'100%'} />
          </div>
          <div className="mb-5 text-sm">
            <Skeleton width={100} />
          </div>
          <div className="mb-20 text-sm">
            <Skeleton width={200} />
          </div>
          <div className="text-md text-bold mb-5">
            <Skeleton width={100} />
          </div>
          <div className="text-sm mb-5">
            <Skeleton width={90} />
          </div>
          <div className="text-light text-xsm">
            <Skeleton width={140} />
          </div>
        </div>
        <LoaderMain systemProducts="Dynamic" systemProductsDetails="LoadingDetails" />
      </div>
    </div>
  );
};
export default DetailsDynamicSkeleton;
